module.exports = __webpack_public_path__ + "res/ic_toggle_on.1fcbe201fa580423a100f640393128e3.png";